import { render, staticRenderFns } from "./RequestUserGroup.vue?vue&type=template&id=6b609390&scoped=true"
import script from "./RequestUserGroup.vue?vue&type=script&lang=js"
export * from "./RequestUserGroup.vue?vue&type=script&lang=js"
import style0 from "./RequestUserGroup.vue?vue&type=style&index=0&id=6b609390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b609390",
  null
  
)

export default component.exports